export enum LoggerEventsEnum {
  VISIT = 'visit',
  INSTALL = 'install',
  FIRST_OPEN = 'first_open',
  PUSH_SUBSCRIPTION = 'push_subscription',
  REGISTRATION = 'registration',
  DEPOSIT = 'deposit',
}
